import React, { useEffect, useMemo, useState } from "react";
import "./BasicInformationStyle.scss";
import { useLocation, useNavigate } from "react-router-dom";
import { getTermPlans } from "../../Redux/TermPlanRedux";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { getPersonalAccidentPremium } from "../../Redux/PersonalAccidentRedux";
import { updateLeadsLife } from "../../Redux/LogsRedux/Life/LifeLeadsRedux";
import Select from "react-select";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import PersonalAccidentCover from "../PersonalAccidentCover/PersonalAccidentCover";
import SumAssuredPage from "../SumAssured/SumAssured";

function BasicInformation() {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [gender, setGender] = useState("");
  const [married, setMarried] = useState("");
  const [message, setMessage] = useState("");
  const [showPlan, setShowPlan] = useState(false);
  const [country, setCountry] = useState([]);
  const [formData, setFormData] = useState({ nationality: "OMAN" });
  const [selectedPlanDetails, setSelectedPlanDetails] = useState(null);

  const location = useLocation();
  const { planDetails } = location.state || {};

  const dispatch = useDispatch();

  const [dob, setDob] = useState({
    year: "",
    month: "",
    day: "",
  });
  const handleChange = (field, value) => {
    setDob((prev) => ({
      ...prev,
      [field]: value,
    }));
    // Clear error message when user selects a value
    if (message) {
      setMessage("");
    }
  };

  const handleSelectChange = (selected, action) => {
    if (!action || !action.name) return;
    const { name } = action;
    const value = selected ? (selected.value ?? selected) : "";
    if (showPlan) {
      setShowPlan(false);
    }
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const today = dayjs();
  const minDobDate = today.subtract(60, "year");
  const maxDobDate = today.subtract(18, "year");

  useEffect(() => {
    if (planDetails?.basicInfo) {
      setGender(planDetails.basicInfo.gender || "");
      setMarried(planDetails.basicInfo.married || "");
      setDob({
        year: planDetails.basicInfo.dob
          ? planDetails.basicInfo.dob.split("-")[2]
          : "",
        month: planDetails.basicInfo.dob
          ? new Date(
              `${planDetails.basicInfo.dob.split("-")[2]}-${planDetails.basicInfo.dob.split("-")[1]}-01`,
            ).toLocaleString(undefined, { month: "short" })
          : "",
        day: planDetails.basicInfo.dob
          ? parseInt(planDetails.basicInfo.dob.split("-")[0], 10)
          : "",
      });
    }
  }, []);

  // Generate month names dynamically and a reasonable year range
  const months = useMemo(() => {
    return Array.from({ length: 12 }, (_, i) =>
      new Date(0, i).toLocaleString(undefined, { month: "short" }),
    );
  }, []);

  const dobString =
    dob.day && dob.month && dob.year
      ? `${String(dob.day).padStart(2, "0")}-${String(
          months.indexOf(dob.month) + 1,
        ).padStart(2, "0")}-${dob.year}`
      : "";

  const handleDobChange = (value) => {
    if (showPlan) {
      setShowPlan(false);
    }
    if (!value) {
      setDob({ year: "", month: "", day: "" });
    } else {
      const [year, month, day] = value.split("-");
      const monthIndex = Number(month) - 1;
      const monthName = months[monthIndex] ?? "";
      setDob({
        year: year || "",
        month: monthName,
        day: day ? parseInt(day, 10) : "",
      });
    }
    if (message) {
      setMessage("");
    }
  };

  // Calculate age from DOB
  const getAge = () => {
    if (!dob.day || !dob.month || !dob.year) return "";
    const monthIndex = months.indexOf(dob.month) + 1;
    const today = new Date();
    const birthDate = new Date(
      `${dob.year}-${String(monthIndex).padStart(2, "0")}-${String(
        dob.day,
      ).padStart(2, "0")}`,
    );
    let age = today.getFullYear() - birthDate.getFullYear();
    const m = today.getMonth() + 1 - monthIndex;
    if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
      age--;
    }
    return age;
  };

  const age = getAge();

  const selectedDobDate =
    dob.year && dob.month && dob.day
      ? dayjs(
          `${dob.year}-${String(months.indexOf(dob.month) + 1).padStart(
            2,
            "0",
          )}-${String(dob.day).padStart(2, "0")}`,
        )
      : null;

  const handleSubmit = () => {
    if (!gender || !married || !dob.year || !dob.month || !dob.day) {
      setMessage("Please select all the fields");
      return;
    }
    else if (age <18) {
      setMessage("Age should be more than 18");
      return;
    }
     else {
      setMessage("");
      const data = {
        gender: gender,
        married: married,
        dob: dobString,
      };

      const payload = {
        transId: localStorage.getItem("LIFE_LEAD_ID"),
        selectedInsuredDetails: data,
        leadStatus: "UPDATED",
      };
      if (planDetails?.coverPlan === "Personal Accident") {
        dispatch(getPersonalAccidentPremium(data)).then((result) => {
          if (result.success) {
            dispatch(updateLeadsLife(payload)).then((response) => {
              if (response.success) {
            const updatedData = {
              ...planDetails,
              basicInfo: data,
              personalAccident: result.data,
            };
            setSelectedPlanDetails(updatedData);
            setShowPlan(true);
            // navigate("/personal-accident-cover", {
            //   state: { planDetails: updatedData },
            // });
              }
            });
          }
        });
      } else if (planDetails?.coverPlan === "Term plan") {
        dispatch(getTermPlans()).then((result) => {
          if (result.success) {
            dispatch(updateLeadsLife(payload)).then((response) => {
              if (response.success) {
            const updatedData = {
              ...planDetails,
              basicInfo: data,
              termPlan: result.data,
            };
            setSelectedPlanDetails(updatedData);
            setShowPlan(true);
            //     navigate("/sum-assured", {
            //       state: { planDetails: updatedData },
            //     });
              }
            });
          }
        });
      } else {
        setMessage("Unknown plan selected!");
      }
    }
  };

  return (
    <>
      <div className="row">
        <div className="col-md-12">
          <h3 className="title pt-4 mb-2">{t(planDetails?.coverPlan)}</h3>
          <h5 className="title subHeader fw-bold py-1 ">
            {t("Enter insured details")}
          </h5>
        </div>
      </div>
      <div className="row">
        <div className="col-md-12 p-3 pb-0">
          <div className={`row d-flex justify-content-center gap-5`}>
            <div className={`section col-md-3 mb-0 border rounded-4 p-3`}>
              <label className="section-label fw-bold mb-2">
                {t("gender")}
              </label>
              <div className="option-group">
                <button
                  type="button"
                  className={`option ${gender === "male" ? "active" : ""} `}
                  onClick={() => {
                    if (showPlan) {
                      setShowPlan(false);
                    }
                    setGender("male");
                    if (message) setMessage("");
                  }}
                >
                  <i className="bi bi-gender-male"></i> {t("male")}
                </button>
                <button
                  type="button"
                  className={`option ${gender === "female" ? "active" : ""}`}
                  onClick={() => {
                    if (showPlan) {
                      setShowPlan(false);
                    }
                    setGender("female");
                    if (message) setMessage("");
                  }}
                >
                  <i className="bi bi-gender-female"></i> {t("female")}
                </button>
              </div>
            </div>
            <div className={`section col-md-3 mb-0 border rounded-4 p-3`}>
              <label className="section-label fw-bold  mb-2">
                {t("are you married")}
              </label>
              <div className="option-group">
                <button
                  type="button"
                  className={`option ${married === "yes" ? "active" : ""}`}
                  onClick={() => {
                    if (showPlan) {
                      setShowPlan(false);
                    }
                    setMarried("yes");
                    if (message) setMessage("");
                  }}
                >
                  {t("yes")}
                </button>
                <button
                  type="button"
                  className={`option ${married === "no" ? "active" : ""}`}
                  onClick={() => {
                    if (showPlan) {
                      setShowPlan(false);
                    }
                    setMarried("no");
                    if (message) setMessage("");
                  }}
                >
                  {t("no")}
                </button>
              </div>
            </div>
            
            <div className="section dob col-md-2 mb-0 border rounded-4 p-3">
              <label className="section-label fw-bold mb-2">
                {t("date of birth")}
              </label>
              <div className="dob-group ">
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DatePicker
                    value={selectedDobDate ? dayjs(selectedDobDate) : null}
                    onChange={(value) => {
                      if (!value || !value.isValid()) {
                        handleDobChange("");
                        return;
                      }
                      handleDobChange(value.format("YYYY-MM-DD"));
                    }}
                    format="DD-MM-YYYY"
                    minDate={minDobDate}
                    maxDate={maxDobDate}
                    views={["year", "month", "day"]}
                    slotProps={{
                      textField: {
                        className: "form-control",
                        fullWidth: true,
                        sx: {
                          "& .MuiInputBase-root": {
                            height: 45,
                          },
                        },
                        // onKeyDown: (e) => e.preventDefault(), 
                      },
                    }}
                  />
                </LocalizationProvider>
              </div>
            </div>
            {dob.year && dob.month && dob.day && (
              <div className="col-md-1 border rounded-4 p-3">
                <div className="">
                  <label className="section-label fw-bold mb-2 ">
                    {t("Age")}
                  </label>
                  <input
                    type="text"
                    className="form-control input-height"
                    value={age}
                    style={{
                      height: "45px",
                      padding: "10px",
                    }}
                    disabled
                  />
                </div>
              </div>
            )}
          </div>
          {message && <p className="mt-1 text-danger p-0 m-0">{t(message)}</p>}
          {!showPlan && (
            <div className="d-flex justify-content-end">
              <button
                type="button"
                onClick={handleSubmit}
                className="btn btn-primary mb-4 mt-3"
              >
                {t("View Plans")}
              </button>
            </div>
          )}
        </div>
        {showPlan && planDetails?.coverPlan == "Personal Accident" && (
          <PersonalAccidentCover planDetails={selectedPlanDetails} />
        )}

        {showPlan && planDetails?.coverPlan == "Term plan" && (
          <SumAssuredPage planDetails={selectedPlanDetails} />
        )}
      </div>
    </>
  );
}

export default BasicInformation;
